import { Component, ElementRef, input, output, viewChild } from '@angular/core';
import { SynDialogComponent } from '@synergy-design-system/angular';

@Component({
  selector: 'app-dialog',
  template: `<syn-dialog
    [style.--width]="width()"
    [label]="header()"
    (synShowEvent)="onShowEvent($event)"
    (synHideEvent)="onHideEvent($event)"
    #dialog
  >
    <ng-content></ng-content>
  </syn-dialog>`,
  styles: [],
  imports: [SynDialogComponent],
})
export class DialogComponent {
  width = input<string | null>(null);
  header = input('');
  onHide = output();
  onShow = output();

  dialog = viewChild.required<ElementRef>('dialog');

  public show(): void {
    this.dialog().nativeElement.show();
  }

  public hide(): void {
    this.dialog().nativeElement.hide();
  }

  onHideEvent(event: Event) {
    // syn-hide is a global event: We have to check for the target
    if (event.target === this.dialog().nativeElement) {
      this.onHide.emit();
    }
  }

  onShowEvent(event: Event) {
    // syn-show is a global event: We have to check for the target
    if (event.target === this.dialog().nativeElement) {
      this.onShow.emit();
    }
  }
}
